module.exports = __webpack_public_path__ + "img/GlobeChek2.8abd2ad6.png";